import React from "react";
import { Box, IconButton } from "@mui/material";
import styled from "styled-components";
import { borderRadius, height, width, colors } from "theme/defaultStyle";
import CustomTooltip from "controls/global/custom-tooltip";
import CloseIcon from "theme/icons/CloseIcon";
import { Signature } from "pages/signatures/providers/manage-signature/SignatureProvider";


const ImagePreviewContainer = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
    marginTop: "16px",
    height: "201px",
    border: "1px dashed #7F7F7F",
    borderRadius: borderRadius.small,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    cursor: disabled ? "not-allowed" : "pointer",
    pointerEvents: disabled ? "none" : "auto",
    opacity: disabled ? 0.5 : 1,
    "& img": {
        maxWidth: "95%",
        maxHeight: "180px",
        objectFit: "contain",
    },
}));

const ClearButtonContainer = styled(Box)({
    position: "absolute",
    top: 5,
    right: 2,
    "& .MuiIconButton-root": {
        padding: "2px",
        "& .MuiSvgIcon-root": {
            color: colors.blue01,
            width: width.xxsmall0,
            height: height.xxsmall0,
        },
    },
});

type Props = {
    signature: Signature;
    handleClearImage: () => void;
    handleImageDoubleClick?: () => void;
    disabled?: boolean;
};

export const ImagePreview = ({ signature, handleClearImage, handleImageDoubleClick, disabled = false }: Props) => {
    return (
        <ImagePreviewContainer
            onDoubleClick={handleImageDoubleClick}
            disabled={disabled}
        >
            <img
                src={signature.file}
                alt="Signature preview"
            />
            <ClearButtonContainer>
                <CustomTooltip
                    title="Clear Signature"
                    placement="left"
                    arrow
                >
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClearImage();
                        }}
                        size="small"
                        disabled={disabled}
                    >
                        <CloseIcon />
                    </IconButton>
                </CustomTooltip>
            </ClearButtonContainer>
        </ImagePreviewContainer>
    );
}